import uuid from 'powtoon-commons/utils/uuid'
import {MINIMUM_STEP_SIZE} from 'powtoon-document/consts/duration'
import {pick} from 'lodash'

export default function lib2SoundItem(libraryItem, extraSoundItemData = {}, extraPlaybackSettings = {}) {
  const {startTime = 0, endTime = libraryItem.length} = extraSoundItemData

  return {
    id: uuid(),
    contentItemId: libraryItem.contentItemId || libraryItem.id,
    audioType: libraryItem.audioType,
    itemType: libraryItem.itemType,
    enterEffect: 'None',
    exitEffect: 'None',
    playbackSettings: {
      baseVolume: 1,
      ...extraPlaybackSettings,
      startTime: extraPlaybackSettings.startTime || 0,
      endTime: extraPlaybackSettings.endTime || Math.min(endTime - startTime, libraryItem.length) || MINIMUM_STEP_SIZE
    },
    ...pick(libraryItem, 'assetType'),
    ...extraSoundItemData
  }
}
